import React from "react";
import Hero from "../components/Hero";
import NavBar from "../components/Nav";
const Home = () => {
	return (
		<>
			<NavBar />
			<Hero />
		</>
	);
};

export default Home;
